/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierFreeMaxStaffSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_FREE_MAX_STAFF')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class TierFreeMaxStaffSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierFreeMaxStaffSettingParser.decode(input).map(res => new TierFreeMaxStaffSetting(res));
    }
    static unsafeDecode(input) {
        return TierFreeMaxStaffSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierFreeMaxStaffSettingParser.encode(data);
    }
    static schema() {
        return TierFreeMaxStaffSettingParser.schema();
    }
}
